import { catcher, catcherNoLoader } from './masterApi';
import * as R from 'ramda';
// import { loaderStore } from '@shelveda/common/stores/loaderStore/loaderStore';
// import { setLoaderApp } from '@shelveda/common/stores/loaderStore/loaderSlice';

// const dispatch = loaderStore.dispatch;
const clientLoader = async (method, link, data, config, version = 1, mess = true) => {
  // dispatch(setLoaderApp(true));
  const res = await catcher(method, link, data, config, version, mess);
  // dispatch(setLoaderApp(false));
  return { ...res };
};

const noCurryClientNoLoader = async (
  method,
  link,
  data,
  params,
  version = 1,
  mess = true,
) => {
  const res = await catcherNoLoader(method, link, data, params, version, mess);
  return { ...res };
};

export const clientNoLoader = R.curryN(5, noCurryClientNoLoader);

export default R.curryN(5, clientLoader);
